export default {
      id: "icon-videoplay-outline-usage",
      viewBox: "0 0 40 30",
      url: __webpack_public_path__ + "icons.svg#icon-videoplay-outline",
      toString: function () {
        return this.url;
      }
    }